import React, { useEffect, useState } from 'react';
import {
    Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, List, ListItem, ListItemText, TextField,
} from '@mui/material';
import { formatSize } from './file-utils';

const INBOX = '/Inbox';

// File yang dikirim ke Disbox lewat tombol "Bagikan" di HP (Galeri,
// WhatsApp, dll - butuh Disbox terpasang sebagai aplikasi): pilih folder
// tujuan lalu upload.
export default function SharedFilesDialog({ open, files, fileManager, onClose, onUpload }) {
    const [target, setTarget] = useState(INBOX);
    const [directories, setDirectories] = useState([]);

    useEffect(() => {
        if (!open || !fileManager) return;
        const dirs = fileManager.getAllDirectoryPaths();
        setDirectories(dirs.includes(INBOX) ? dirs : [INBOX, ...dirs]);
        setTarget(INBOX);
    }, [open, fileManager]);

    const total = (files || []).reduce((sum, file) => sum + file.size, 0);
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Simpan ke Disbox</DialogTitle>
            <DialogContent>
                <DialogContentText>{(files || []).length} file ({formatSize(total)}) dari aplikasi lain.</DialogContentText>
                <List dense sx={{ maxHeight: 220, overflow: 'auto' }}>
                    {(files || []).map((file, i) => (
                        <ListItem key={`${file.name}-${i}`} disableGutters>
                            <ListItemText primary={file.name} secondary={formatSize(file.size)} primaryTypographyProps={{ sx: { wordBreak: 'break-all' } }} />
                        </ListItem>
                    ))}
                </List>
                <TextField select fullWidth margin="dense" label="Folder tujuan" value={target} onChange={(e) => setTarget(e.target.value)} SelectProps={{ native: true }} InputLabelProps={{ shrink: true }}>
                    {directories.map((dir) => (
                        <option key={dir} value={dir}>{dir === '' ? '/ (Root)' : dir}{dir === INBOX && !fileManager.getFile(INBOX) ? ' (baru)' : ''}</option>
                    ))}
                </TextField>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Batal</Button>
                <Button variant="contained" onClick={() => onUpload(files, target)} disabled={!files || files.length === 0}>Upload</Button>
            </DialogActions>
        </Dialog>
    );
}
